import * as Editable from '../../../Data/Editable'
import {DeliveryTab} from './DeliveryState'
import {DeliverySubAction} from './DeliveryActions'
import {OrderDetailsFeedback} from '../OrderDetailsFeedback'
import * as DeliveryAddress from '../../../Entities/DeliveryAddress'
import {update} from '../../../Data/ObjectHelper'
import * as OrderResource from '../../../Request/OrderResource'
import {decodeHttpResponse} from '../../../Data/Http'
import {orderDecoder} from '../../../Entities/Order'
import {FeedbackLoop} from '../../../Data/FeedbackLoop'

export function initDelivery(deliveryAddress: DeliveryAddress.DeliveryAddress): DeliveryTab {
    return {
        deliveryAddress,
        deliveryAddressForm: {
            type: 'Locked',
        },
    }
}

type DeliveryLoop =
    FeedbackLoop<DeliveryTab, OrderDetailsFeedback>

export function deliveryReducer(
    orderId: number,
    action: DeliverySubAction,
    state: DeliveryTab,
): DeliveryLoop {
    switch (action.type) {
        case 'EditDelivery': {
            return {
                state: update({
                    deliveryAddressForm: {
                        type: 'Pending',
                        value: state.deliveryAddress
                    },
                }, state),
                feedback: [],
            }
        }
        case 'DeliveryName1Changed':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryName1: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryName2Changed':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryName2: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryName3Changed':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryName3: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryName4Changed':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryName4: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryFloorChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryFloor: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryRoomChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryRoom: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryStreetChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryStreet: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryHouseNumberChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryHouseNumber: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryZipCodeChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryZipCode: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryCityChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryCity: action.value,
                }), deliveryInformation),
                state)
        case 'DeliveryCountryChanged':
            return updateDeliveryAddressForm(
                deliveryInformation => update(({
                    deliveryCountry: action.value,
                }), deliveryInformation),
                state)
        case 'SaveDelivery': {
            const {deliveryAddressForm} = state
            if (deliveryAddressForm.type === 'Pending' || deliveryAddressForm.type === 'Failure') {
                const deliveryAddress = deliveryAddressForm.value
                return {
                    state: update({
                        deliveryAddressForm: {
                            type: 'Loading',
                            value: deliveryAddress,
                        },
                    }, state),
                    feedback: [{
                        type: 'SendRequest',
                        identifier: {
                            type: 'OrderDeliveryAddressPatch',
                        },
                        httpRequest: OrderResource.patchDeliveryAddress(
                            deliveryAddress,
                            orderId,
                        ),
                    }],
                }
            }
            return {state, feedback: []}
        }
        case 'DeliveryInformationUpdateResponse': {
            const result =
                decodeHttpResponse(
                    orderDecoder(),
                    action.result)
            if (state.deliveryAddressForm.type !== 'Locked') {
                return (() => {
                    switch (result.type) {
                        case 'Ok':
                            return {
                                state: update({
                                    deliveryAddress:
                                        DeliveryAddress.fromOrder(result.value),
                                    deliveryAddressForm: {
                                        type: 'Locked',
                                    },
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                        case 'Err':
                            return {
                                state: update({
                                    deliveryAddressForm: {
                                        type: 'Failure',
                                        value: state.deliveryAddressForm.value,
                                        error: result.error,
                                    }
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                    }
                })()
            } else {
                return {state, feedback: []}
            }
        }
        case 'DiscardDelivery': {
            return {
                state: update({deliveryAddressForm: {type: 'Locked'}}, state),
                feedback: [],
            }
        }
    }
}

function updateDeliveryAddressForm(
    fn: (deliveryAddress: DeliveryAddress.DeliveryAddress) => DeliveryAddress.DeliveryAddress,
    state: DeliveryTab,
): DeliveryLoop {
    return {
        state: update({
            deliveryAddressForm:
                Editable.map(fn, state.deliveryAddressForm),
        }, state),
        feedback: [],
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/Delivery/DeliveryReducer.ts